import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

export default function save({ attributes }) {
  const {
    linkUrl,
    linkTitle,
    linkTarget,
    linkTile,
    biteRef,
    buttonType,
    biteClass,
    flexClass,
  } = attributes;

  // hoverable tilte
  const tileClass = linkTile ? 'bf_tile' : '';

  const blockProps = useBlockProps.save();

  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `bf_layout ${flexClass}`,
  });

  return (
    <>
      {buttonType === 'a' ? (
        <a {...blockProps} href={linkUrl} target={linkTarget} rel={'noopener'}>
          <span {...innerBlocksProps}>{children}</span>
        </a>
      ) : (
        <button {...blockProps}>
          <span {...innerBlocksProps}>{children}</span>
        </button>
      )}
    </>
  );
}
